const BASE_URL = 'https://cryptocashbackend-f55cc665d1b6.herokuapp.com/'
//https://vegaolga5938.store
//http://127.0.0.1:5000
export default BASE_URL
